import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@material-ui/core/SvgIcon';

const DgLogoIcon = ({ className, ...props }) => (
  <SvgIcon
    width={64}
    height={70}
    viewBox="0 0 64 70"
    fill="none"
    className={classnames({
      icon: true,
      [className]: !!className
    })}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.6977 2.1776C54.1025 4.99213 64.0959 20.037 63.3865 37.7202C62.7661 53.1858 50.4209 67.3225 34.7324 69.135C24.9738 70.2631 15.0271 69.8335 5.1631 69.8994C2.25717 69.9184 0.133261 67.4562 0.113694 64.4433C0.0310103 51.5691 0.0619379 51.0424 8.2673e-05 38.1676C-0.00875378 36.3024 0.689957 35.7891 2.48691 36.0781C9.70819 37.2391 15.3257 43.6433 15.4203 51.0304C15.4468 54.4546 16.783 55.9376 20.1447 55.8901C24.2227 55.833 28.3777 55.9509 32.3579 55.2183C43.0696 53.2448 48.2617 42.905 47.1571 32.8199C45.8638 21.0104 36.186 14.3407 25.5494 14.823C20.341 15.0588 15.0063 14.958 9.88682 14.0803C3.8654 13.0472 -0.219566 6.98468 0.263283 0C12.8918 0.636929 25.5191 0.0880928 37.6977 2.1776Z"
      fill="url(#paint0_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.44423 31.2151C11.1631 31.2151 13.2893 38.5069 15.2399 37.1918C17.1905 35.8767 13.784 29.0805 10.0759 25.3956C8.05626 23.3886 4.61117 22.1922 2.05062 21.9054C1.47707 21.8412 0.476412 21.6509 0.476412 23.5819C0.476412 26.2528 -0.177749 31.2151 1.44423 31.2151Z"
      fill="#FD2473"
    />
    <defs>
      <linearGradient id="paint0_linear" x1={0} y1={0} x2={0} y2={69.9268} gradientUnits="userSpaceOnUse">
        <stop stopColor="#EC286F" />
        <stop offset={1} stopColor="#FF2373" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export default DgLogoIcon;
